import * as React from "react";
import ProgressiveImage from "react-progressive-image-loading";

import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

import { FS, Kit, Text, TryWithExpo } from "../components";

type ClassNames = "container" | "left" | "right" | "expo" | "btns" | "qrCode" | "link" | "video";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        [theme.breakpoints.down("md")]: {
            minHeight: 0,
            flexDirection: "column !important" as "column",
            marginBottom: 100
        }
    },
    left: {
        width: "50vw",
        boxSizing: "border-box",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        overflow: "hidden",
        [theme.breakpoints.down("md")]: {
            width: "100%",
            height: "62vw",
            marginTop: theme.spacing.unit * 2,
            marginBottom: theme.spacing.unit * 2
        }
    },
    video: {
        height: "100%",
        width: "100%",
        objectFit: "cover"
    },
    right: {
        width: "50vw",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        paddingLeft: theme.spacing.unit * 4,
        paddingRight: theme.spacing.unit * 4,
        [theme.breakpoints.down("md")]: {
            width: "100%",
            flexDirection: "column"
        }
    },
    btns: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2
    },
    expo: {
        display: "flex",
        [theme.breakpoints.down("md")]: {
            alignItems: "center"
        }
    },
    qrCode: {
        marginLeft: theme.spacing.unit * 2
    },
    link: {
        color: theme.typography.body1.color
    }
});

interface KitOverviewProps {
    kit: Kit
}

class KitOverview extends React.Component<WithStyles<ClassNames> & KitOverviewProps> {

    public renderImage = (src: string, style: React.CSSProperties) => (
        <div
            className={this.props.classes.left}
            style={Object.assign(style, { backgroundImage: `url(${src})` })}
        />
    );

    public render() {
        const {classes, kit} = this.props;
        const containerStyle: React.CSSProperties = {
            flexDirection: "row"
        };
        return (
            <FS className={classes.container} style={containerStyle} id={kit.id}>
                {
                    !kit.video && (
                        <ProgressiveImage
                            preview={kit.thumbnailPreview}
                            src={kit.thumbnail}
                            render={this.renderImage}
                        />
                    )
                }
                {
                    kit.video && (
                        <div className={classes.left}>
                            <video className={classes.video} autoPlay={true} loop={true} muted={true}>
                                <source src={kit.video} type="video/mp4" />
                            </video>
                        </div>
                    )
                }
                <div className={classes.right}>
                    <Text variant="title2">{kit.name}</Text>
                    <Text variant="title3">{kit.overview}</Text>
                    <Text>
                    {kit.description}
                    </Text>

                    <div className={classes.expo}>
                        <TryWithExpo
                            name={kit.name}
                            expo={kit.expo}
                            color={kit.color}
                            testFlight={kit.testFlight}
                            apk={kit.apk}
                        />
                    </div>
                </div>
            </FS>
        );
    }
}

export default  withStyles(styles)<KitOverviewProps>(KitOverview);



// WEBPACK FOOTER //
// ./src/boarding/BoardingPass.tsx